import { render } from "./ProductDetail_check.vue?vue&type=template&id=72f28028&scoped=true"
import script from "./ProductDetail_check.vue?vue&type=script&lang=js"
export * from "./ProductDetail_check.vue?vue&type=script&lang=js"

import "./ProductDetail_check.vue?vue&type=style&index=0&id=72f28028&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f28028"]])

export default __exports__